import * as React from "react";
import type { SVGProps } from "react";
const SvgGlobe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M4.65 8.358a8.22 8.22 0 0 1 5.368-4.317q-.238.335-.481.738c-.553.92-1.1 2.11-1.462 3.579zM12 4.118a9.5 9.5 0 0 0-1.09 1.484c-.43.715-.863 1.63-1.18 2.756h4.54a11.3 11.3 0 0 0-1.18-2.756A9.5 9.5 0 0 0 12 4.12m2.608 5.84H9.39c-.092.63-.145 1.31-.145 2.042 0 .73.053 1.411.145 2.042h5.216c.092-.63.145-1.311.145-2.042s-.053-1.411-.145-2.042m1.615 4.084c.083-.639.13-1.32.13-2.042 0-.723-.047-1.403-.13-2.042h3.72a8.218 8.218 0 0 1 0 4.084zm-1.954 1.6H9.73c.317 1.125.75 2.04 1.179 2.755a9.5 9.5 0 0 0 1.09 1.484 9.5 9.5 0 0 0 1.09-1.484c.43-.714.862-1.63 1.18-2.755m-.288 4.317q.238-.335.481-.738c.553-.921 1.1-2.11 1.462-3.579h3.425a8.22 8.22 0 0 1-5.368 4.317m1.943-11.601a13 13 0 0 0-1.462-3.579q-.243-.404-.48-.738a8.22 8.22 0 0 1 5.367 4.317zm-11.867 1.6h3.72c-.083.639-.13 1.32-.13 2.042 0 .723.047 1.403.13 2.042h-3.72A8.2 8.2 0 0 1 3.799 12c0-.705.09-1.39.257-2.042m.594 5.684h3.425c.363 1.468.91 2.658 1.462 3.579q.243.403.48.738a8.22 8.22 0 0 1-5.367-4.317M12 2.2c-5.413 0-9.8 4.388-9.8 9.8s4.387 9.8 9.8 9.8c5.412 0 9.8-4.388 9.8-9.8S17.411 2.2 12 2.2"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgGlobe;
